<template>
  <div class="container">
    <div class="head_bg">
      <comm-head></comm-head>
      <div class="head_con">
        <h1>加入我们</h1>
        <div></div>
      </div>
      <div class="head_desc">联系电话：18668172787，欢迎咨询、背调及其他人事相关事务沟通。</div>
    </div>
    <div class="fuli">
      <h1>福利待遇</h1>
      <div>
        <div
          class="item"
          v-for="(item, index) in fuli_list"
          :key="index"
          :class="{ mar_r_15: (index + 1) % 3 != 0, mar_b_24: index < 3 }"
        >
          <img :src="item.icon" alt="" />
          <div>
            <p>{{ item.name }}</p>
            <p>{{ item.describe }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="hj_bc">
      <div class="hj">
        <h1>办公环境</h1>
        <div class="hj_img">
          <ul>
            <li
              v-for="item in 5"
              :key="item"
              :class="{ w_50: liActive == item }"
              @mouseenter="handleMouseEnter(item)"
              @mouseleave="handleMouseLeave(item)"
            >
              <div class="shadow" v-show="liActive != item"></div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="join_us">
      <h1>加入我们</h1>
      <div class="job_content_section">
        <span>职位名称</span>
        <span>职位类别</span>
        <span>操作</span>
      </div>
      <div v-for="(jobDetail, index) in jobDetailData" :key="index">
        <div
          class="job_content_cell"
          @click="didSelectedCellAction(index)"
          :class="{ job_content_cell_selected: cellIndex === index }"
        >
          <span>{{ jobDetail.Name }}</span>
          <span>{{ jobDetail.Type }}</span>
          <span>
            <!-- <a href="mailto:zhaopin@duomai.com">现在申请</a> -->
          </span>
        </div>
        <div class="jobDesc">
          <div style="border-bottom: 1px solid #e5e5e5; padding-bottom: 15px">
            <span style="font-size: 18px; color: #ff9200">岗位职责：</span>
            <pre style="margin-top: 8px">{{ jobDetail.Desc }}</pre>
          </div>
          <div style="margin-top: 15px">
            <span style="font-size: 18px; color: #ff9200">岗位要求：</span>
            <pre style="margin-top: 8px">{{ jobDetail.Requirement }}</pre>
          </div>
          <div>
            <!-- <a href="mailto:zhaopin@duomai.com">现在申请</a> -->
          </div>
        </div>
      </div>
    </div>
    <foot-cpright></foot-cpright>
  </div>
</template>

<script>
import commHead from "@/components/comm-head.vue";
import footCpright from "@/components/foot-cpright.vue";
export default {
  data() {
    return {
      fuli_list: [
        {
          name: "津贴与补助",
          describe: "餐补+班车及交通补+全勤奖+五险一金",
          icon: require("../assets/images/fuli_1.png"),
        },
        {
          name: "假期",
          describe: "双休及法定节假日",
          icon: require("../assets/images/fuli_2.png"),
        },
        {
          name: "定期团建",
          describe: "聚餐/K歌/度假村等，由你说了算！",
          icon: require("../assets/images/fuli_3.png"),
        },
        {
          name: "年度旅游",
          describe: "世界很大，咱们一起出去看看。",
          icon: require("../assets/images/fuli_4.png"),
        },
        {
          name: "休闲时间",
          describe: "零食区！健身房！母婴室！休息室！",
          icon: require("../assets/images/fuli_5.png"),
        },
        {
          name: "其他福利",
          describe: "年度体检，生日礼物，节假日福利",
          icon: require("../assets/images/fuli_6.png"),
        },
      ],
      liActive: 1,
      jobTypeData: [],
      jobDetailData: [],
      baseImageUrl: "https://api.duomai.cn/data/files/",
      page: 1,
      pageSize: 50,
      totalPage: 0,
      currentIndex: 0,
      cellIndex: -1,
      interval: null,
    };
  },
  components: {
    commHead,
    footCpright,
  },
  created() {
    const { getJob, handleImgCarousel } = this;
    getJob();
    handleImgCarousel();
  },
  methods: {
    getJob() {
      this.$http
        .get("site/job", {
          params: {
            Page: this.page,
            Pagesize: this.PageSize,
          },
        })
        .then((response) => {
          this.jobTypeData = response.d.Types;
          this.jobDetailData = response.d.Results;
          this.totalPage = response.d.TotalPage;
        });
    },
    handleImgCarousel() {
      this.interval = setInterval(() => {
        let { liActive } = this;
        this.liActive = liActive >= 5 ? 1 : ++liActive;
      }, 2000);
    },
    handleMouseEnter(index) {
      clearInterval(this.interval);
      this.liActive = index;
    },
    handleMouseLeave() {
      const { handleImgCarousel } = this;
      this.liActive = 0;
      handleImgCarousel();
    },
    didSelectedCellAction(index) {
      let thisSelectedCell = document.getElementsByClassName("jobDesc")[index];
      if (this.cellIndex === index) {
        thisSelectedCell.style.height = 0;
        thisSelectedCell.style.padding = 0;
        thisSelectedCell.style.borderBottom = "none";
        this.cellIndex = -1;
        return;
      }
      this.cellIndex = index;
      this.jobDetailData.map((item, i) => {
        let otherSelectedCell = document.getElementsByClassName("jobDesc")[i];
        if (i === index) {
          thisSelectedCell.style.height =
            thisSelectedCell.scrollHeight + 44 + "px";
          thisSelectedCell.style.padding = "20px";
          thisSelectedCell.style.borderBottom = "1px solid #e5e5e5";
        } else {
          otherSelectedCell.style.height = 0;
          otherSelectedCell.style.padding = 0;
          otherSelectedCell.style.borderBottom = "none";
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  & .head_bg {
    height: 300px;
    background-image: url("../assets/images/banner_jrwm.png");
    position: relative;
    & .head_con {
      width: 1200px;
      position: absolute;
      top: 200px;
      left: 50%;
      transform: translateX(-50%);
      & h1 {
        color: #fff;
        margin-bottom: 10px;
      }
      & div {
        width: 80px;
        height: 4px;
        background-color: #fff;
      }
    }
    & .head_desc {
      width: 1200px;
      position: absolute;
      top: 270px;
      left: 50%;
      transform: translateX(-50%);
      color: #fff;
    }
  }

  & .fuli {
    width: 1200px;
    margin: 0 auto;
    padding-top: 64px;
    & h1 {
      margin-bottom: 32px;
    }
    & > div {
      display: flex;
      margin-bottom: 80px;
      flex-wrap: wrap;
      & .mar_r_15 {
        margin-right: 15px;
      }
      & .mar_b_24 {
        margin-bottom: 24px;
      }
      & .item {
        width: 390px;
        height: 140px;
        display: flex;
        align-items: center;
        background-color: #fff;
        border-radius: 5px;
        & img {
          margin-left: 20px;
          margin-right: 22px;
        }
        & div {
          & > p:first-child {
            font-size: 24px;
            color: #000000;
            letter-spacing: 0;
            margin-bottom: 10px;
          }
          & > p:last-child {
            font-size: 16px;
            color: #666666;
            letter-spacing: 0;
          }
        }
      }
    }
  }

  & .hj_bc {
    background-color: #fff;
    padding: 64px 0 80px;
    & .hj {
      width: 1200px;
      margin: 0 auto;
      & h1 {
        margin-bottom: 32px;
      }
      & .hj_img {
        height: 500px;
        overflow: hidden;
        & ul {
          width: 100%;
          height: 100%;
          display: table;
          table-layout: fixed;
          margin: 0;
          padding: 0;
          & li {
            display: table-cell;
            vertical-align: bottom;
            position: relative;
            width: 20%;
            background-repeat: no-repeat;
            background-position: center center;
            transition: all 500ms ease;
            height: 100%;
            position: relative;
            & .shadow {
              width: 100%;
              height: 500px;
              background-color: rgba(0, 0, 0, 0.3);
            }
          }
          & li:nth-child(1) {
            background-image: url("../assets/images/hj_1.png");
          }
          & li:nth-child(2) {
            background-image: url("../assets/images/hj_2.png");
          }
          & li:nth-child(3) {
            background-image: url("../assets/images/hj_3.png");
          }
          & li:nth-child(4) {
            background-image: url("../assets/images/hj_4.png");
          }
          & li:nth-child(5) {
            background-image: url("../assets/images/hj_5.png");
          }
          & .w_50 {
            width: 50% !important;
          }
        }
      }
    }
  }

  & .join_us {
    width: 1200px;
    margin: 0 auto;
    padding-top: 64px;
    margin-bottom: 80px;
    & h1 {
      margin-bottom: 32px;
    }
    & .job_content_section {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      font-size: 16px;
      color: #242424;
      height: 50px;
      line-height: 40px;
      border-bottom: 1px solid #e5e5e5;
      padding-left: 15px;
      font-weight: 600;
      & span {
        width: 300px;
      }

      & span:nth-child(2) {
        text-align: left;
        width: 300px;
      }
      & span:nth-child(3) {
        width: 100px;
        text-align: center;
      }
    }

    & .job_content_cell {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      font-size: 16px;
      color: #242424;
      height: 60px;
      border-bottom: 1px solid #e5e5e5;
      padding-left: 15px;
      & span {
        width: 300px;
        line-height: 35px;
        & > a {
          color: white;
        }
      }

      & span:nth-child(2) {
        text-align: left;
      }

      & span:nth-child(3) {
        width: 100px;
        text-align: center;
        background-color: #fd9526;
        border-radius: 5px;
        color: white;
      }
    }

    & .job_content_cell_selected {
      background: rgba(241, 241, 241, 1);
    }

    & .jobDesc {
      font-size: 18px;
      color: #666666;
      overflow: hidden;
      height: 0;
      transition: height 0.4s ease-in-out;
      & div:nth-child(3) {
        margin-top: 24px;
        & a {
          width: 100px;
          line-height: 35px;
          text-align: center;
          background-color: #fd9526;
          border-radius: 5px;
          color: white;
          display: block;
        }
      }
    }
  }
}
</style>
